module.exports = __webpack_public_path__ + "static/media/inf_54og64.ede56b7a.mp3";